import { Injectable } from '@angular/core';
import { Day, IDate, Month, Year } from '../interfaces/date.interface';

@Injectable({
  providedIn: 'root'
})
export class DateUtils {
  public initDays(d: Date): Day[] {
    const day = ('0' + d.getDate()).slice(-2); // Get the day of the month (1-31) and ensure it has two digits
    return [
      {
        key: 'day1',
        value: day[0]
      },
      {
        key: 'day2',
        value: day[1]
      }
    ];
  }

  public initMonths(d: Date): Day[] {
    const month = ('0' + (d.getMonth() + 1)).slice(-2); // Get the month (0-11) and add 1 to make it (1-12), ensure it has two digits
    return [
      {
        key: 'month1',
        value: month[0]
      },
      {
        key: 'month2',
        value: month[1]
      }
    ];
  }

  public initYear(d: Date): Day[] {
    const year = d.getFullYear().toString(); // Get the full year
    return year.split('').map((digit, index) => ({
      key: `year${index + 1}`,
      value: digit
    }));
  }

  public combineDays(days: Day[]): string {
    return this.combine(days);
  }

  public combineMonths(months: Month[]): string {
    return this.combine(months);
  }

  public combineYears(years: Year[]): string {
    return this.combine(years);
  }

  public convertDateToIDate(dateInput: Date | string): IDate {
    const date = new Date(dateInput);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return {
      day,
      month,
      year
    };
  }

  public convertIDateToDate(iDate: IDate): Date {
    const { day, month, year } = iDate;
    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  }

  public getDateISOIgnoringTimeZone(date: Date | null): string {
    if (!date) {
      return '';
    }

    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
  }

  public IDateToDashedDateFormat(date: IDate): string {
    return !date ? '' : `${date.year}-${date.month.padStart(2, '0')}-${date.day.padStart(2, '0')}`;
  }

  public DateToDashedDateFormat(date: Date): string {
    return this.IDateToDashedDateFormat(this.convertDateToIDate(date));
  }

  public calculateYearDifference(referenceDate: Date, comparisonDate: Date): number {
    let yearDifference = comparisonDate.getFullYear() - referenceDate.getFullYear();

    const monthDifference = comparisonDate.getMonth() - referenceDate.getMonth();
    const isReferenceDateLaterInYear =
      monthDifference < 0 || (monthDifference === 0 && comparisonDate.getDate() < referenceDate.getDate());

    if (isReferenceDateLaterInYear) {
      yearDifference--;
    }

    return yearDifference;
  }

  private combine(values: Array<Day | Month | Year>): string {
    return values.map((value) => value.value).join('');
  }
}
